/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SessionFrequencyEnum } from './sessionFrequencyEnum';


/**
 * Creates or changes a treatment plan. Expects the patient in the context.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface TreatmentPlanWrite { 
    appointment?: number | null;
    collaboardLinkId?: string;
    therapyGoals?: string;
    plannedProcedures?: string;
    prognosis?: string;
    notes?: string;
    patientAgreements?: string;
    plannedSessionCount?: number | null;
    sessionFrequency?: SessionFrequencyEnum | null;
    sessionFrequencyOther?: string;
}
export namespace TreatmentPlanWrite {
}

export const TreatmentPlanWrite_appointment_Validators: ValidatorFn[] =
    [ ];

export const TreatmentPlanWrite_collaboardLinkId_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const TreatmentPlanWrite_therapyGoals_Validators: ValidatorFn[] =
    [ ];

export const TreatmentPlanWrite_plannedProcedures_Validators: ValidatorFn[] =
    [ ];

export const TreatmentPlanWrite_prognosis_Validators: ValidatorFn[] =
    [ ];

export const TreatmentPlanWrite_notes_Validators: ValidatorFn[] =
    [ ];

export const TreatmentPlanWrite_patientAgreements_Validators: ValidatorFn[] =
    [ ];

export const TreatmentPlanWrite_plannedSessionCount_Validators: ValidatorFn[] =
    [  Validators.min(1), Validators.max(32767),];

export const TreatmentPlanWrite_sessionFrequency_Validators: ValidatorFn[] =
    [ ];

export const TreatmentPlanWrite_sessionFrequencyOther_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];


